import { createFileRoute } from '@tanstack/react-router';
import { WorkspacePushSettingsLayoutRoute } from '@/pages/workspaces/settings/actions/push/routing';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/settings/actions/push')({
  component: WorkspacePushSettingsLayoutRoute,
});
